export const sanitizeEmail = (email: string) => email.toLocaleLowerCase().trim();

export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
